  export default {
    name: 'DashboardPlanejamento',
    data() {
      return {
        dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
        usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
        pagamentosSolicitados: [],
        pagamentosAprovacoes: [],
        reinvidicacoes: [],
        periodo: '',
        anos: [],
        ano: null,
        valoresPagamentos: null,
        vazio: '',
        unidadesNegocio: [],
        idUnidadeNegocio: '',
        periodos: [],
        tableHeaderPagamentosSolicitados: [
          {
            name: this.$tc('label.codigo_cliente', 1),
            sortType: 'idExternoCliente',
            classes: [],
          },
          {
            name: this.$tc('label.cliente', 1),
            sortType: 'cliente',
            classes: [],
          },
          {
            name: this.$tc('label.aprovador', 1),
            sortType: 'aprovador',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.tipo_acordo'),
            sortType: 'descTipoAcordo',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.desc_acordo'),
            sortType: 'descAcordo',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.status_pagamento', 2),
            sortType: 'status',
            classes: [],
          },
          {
            name: this.$tc('label.valor_pagamento', 2),
            sortType: 'vlrPagamento',
            classes: ['md-hide-medium'],
          },
        ],
        tableHeaderPagamentosAprovacoes: [
          {
            name: this.$tc('label.codigo_cliente', 1),
            sortType: 'idExternoCliente',
            classes: [],
          },
          {
            name: this.$tc('label.cliente', 1),
            sortType: 'cliente',
            classes: [],
          },
          {
            name: this.$tc('label.solicitante', 1),
            sortType: 'aprovador',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.tipo_acordo'),
            sortType: 'descTipoAcordo',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.desc_acordo'),
            sortType: 'descAcordo',
            classes: ['md-hide-medium'],
          },
          {
            name: this.$tc('label.status_pagamento', 2),
            sortType: 'status',
            classes: [],
          },
          {
            name: this.$tc('label.valor_pagamento', 2),
            sortType: 'vlrPagamento',
            classes: ['md-hide-medium'],
          },
        ],
        filtro: {},
      };
    },
    methods: {},
  };



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/pagamento.js